import Accordion from '../components/Accordion'
import { isEmpty } from '../misc/Utils'

export default class Contact {
    constructor() {
        this.cacheDom()
        this.bindEvents()
        new Accordion()
    }

    cacheDom() {
        this.form = document.getElementById('contact_form')
        this.inputs = document.querySelectorAll('.input, .textarea')
    }

    bindEvents() {
        Array.prototype.forEach.call(this.inputs, (element) => {
            element.addEventListener('focus', this.onFocus.bind(this))
            element.addEventListener('blur', this.onBlur.bind(this))
        })

        this.form.addEventListener('submit', this.formSubmit.bind(this))
    }

    onFocus(event) {
        const parent = event.target.parentNode
        parent.classList.add('is-active')
    }

    onBlur(event) {
        const parent = event.target.parentNode
        const value = event.target.value

        if (isEmpty(value)) {
            parent.classList.remove('is-active')
        }
    }

    formSubmit(event) {
        event.preventDefault()
        event.stopPropagation()
        console.log('Form submitted')
    }
}
